import PropTypes from 'prop-types';
import React from 'react';

class ProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    percent: PropTypes.number,
  };

  render() {
    const { percent } = this.props;
    const color = percent < 80 ? (percent < 50 ? 'm--bg-danger' : 'm--bg-warning') : 'm--bg-success';

    return (
      <div className="progress" data-tip={Math.floor(parseFloat(percent)) + '%'}>
        <div
          className={'progress-bar ' + color}
          style={{
            width: percent + '%',
          }}
        />
      </div>
    );
  }
}

export default ProgressBar;
